module.exports = __webpack_public_path__ + "img/logo.510d0e8a.png";